package org.zq.astrock_ai.storage

import kotlinx.browser.localStorage

actual object WatchlistLocalStorage {
    actual fun load(): List<String> = runCatching {
        decodeWatchlist(localStorage.getItem(KEY))
    }.getOrDefault(emptyList())

    actual fun save(codes: List<String>) {
        runCatching { localStorage.setItem(KEY, encodeWatchlist(codes)) }
    }

    private const val KEY = "astockai.research.watchlist"
}

actual object AdaptiveLearningStorage {
    actual fun load(): String? = runCatching { localStorage.getItem(KEY) }.getOrNull()

    actual fun save(raw: String) {
        runCatching { localStorage.setItem(KEY, raw) }
    }

    private const val KEY = "astockai.research.adaptiveLearning.v1"
}

actual object QuantScanSignalStorage {
    actual fun load(): Map<String, String> = runCatching {
        decodeSignalMap(localStorage.getItem(KEY))
    }.getOrDefault(emptyMap())

    actual fun save(signals: Map<String, String>) {
        runCatching { localStorage.setItem(KEY, encodeSignalMap(signals)) }
    }

    private const val KEY = "astockai.research.quantScanSignals.v1"
}

actual object QuantScanHistoryStorage {
    actual fun load(): String? = runCatching { localStorage.getItem(KEY) }.getOrNull()

    actual fun save(raw: String) {
        runCatching { localStorage.setItem(KEY, raw) }
    }

    private const val KEY = "astockai.research.quantScanHistory.v1"
}

actual object QuantScanPrefsStorage {
    actual fun load(): QuantScanPrefs = runCatching {
        decodeScanPrefs(localStorage.getItem(KEY))
    }.getOrDefault(QuantScanPrefs())

    actual fun save(prefs: QuantScanPrefs) {
        runCatching { localStorage.setItem(KEY, encodeScanPrefs(prefs)) }
    }

    private const val KEY = "astockai.research.quantScanPrefs.v1"
}

actual object HoldingsLocalStorage {
    actual fun load(): String? = runCatching { localStorage.getItem(KEY) }.getOrNull()

    actual fun save(raw: String) {
        runCatching { localStorage.setItem(KEY, raw) }
    }

    private const val KEY = "astockai.research.holdings.v1"
}
